// extracted by mini-css-extract-plugin
export var description = "AboutProduct-module--description--lPkcF";
export var image = "AboutProduct-module--image--kPIJP";
export var imageWrapper = "AboutProduct-module--imageWrapper--dpEpe";
export var information = "AboutProduct-module--information--ELPe3";
export var label = "AboutProduct-module--label--yPuMv";
export var labelLight = "AboutProduct-module--labelLight--jO+TF";
export var taste = "AboutProduct-module--taste--oW3j3";
export var text = "AboutProduct-module--text--Yzqo5";
export var wrapper = "AboutProduct-module--wrapper--awmBi";